import service from '../config/axios.config';
import { addAlert } from './alerts.action';

export const SET_NOTIFICATIONS = 'cx-ray/EMPLOYEE/SET_NOTIFICATIONS';

export const setNotifications = notifications => async dispatch => {
  const url = `/notificationsSetting`;

  try {
    const { data } = await service.put(url, notifications);

    dispatch({
      type: SET_NOTIFICATIONS,
      payload: data.notifications
    });
  } catch (error) {
    dispatch(
      addAlert({ message: error.message, severity: 'error' })
    );
  }
};